import React from 'react';
import type Trip from '@this/domain/trip/trip2';
import { OrganizationAsideButtons } from './organization_aside_buttons';

interface Props {
  trip: Trip;
}

export const OrganizationInfoButton: React.FC<Props> = ({ trip }) => {
  const organizationId = trip?.organization?.id;

  if (!organizationId) {
    return null;
  }

  return (
    <section>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <OrganizationAsideButtons organizationId={organizationId} showHeading />
      </div>
    </section>
  );
};
